import React, { useState, useEffect } from "react";
import ShortNameBox from "./ShortNameBox";
import {subjectDuration,getSubjectStatus, formatOnlyDateRange, formatDateRange, calculateTotalMonths} from "../../utils/commonFunction.js";
import moment from "moment";
import Str from "../common/Str";
import MentoredSubject from "./MentoredSubject";
import { ProgramIcons } from "./CommonCourseComponents";
import { loadGraphModel } from "@tensorflow/tfjs";
import { useHistory } from "react-router-dom";
const stc = require('string-to-color');

const SubjectHeadBox = (props) => {
  const row = props.content;
  const [status, setStatus] = useState(null);
  const [data, setData] = useState(null);
  const history = useHistory()


  const dateFormat = "Do MMM YY";
  return (
    <>
      <div className="lecture-detail-top d-flex justify-content-between  shift-move">
        <div className="lecture-detail-top-left">
          <div className="lecture-bx-info  d-flex">
            {/* <div className="icon honours-icon"><ProgramIcons icon={"honours"}/></div> */}
            <div className="lecture-bx-info-rgt">
              <h3 title={row.name}>{row.name}</h3>
              <div className="course-statistics-count">
                {props.isAdmin != 1 ? (
                  (() => {
                    if (row.type === "selfplaced" && row.subject_type === "shortcourse") {
                      switch (row.student_intake_status) {
                        case 0:
                          return (
                            <p title={formatOnlyDateRange(row?.start, row?.end)}>
                              <i className="fal fa-calendar-clock"></i>
                            </p>
                          );
                        case 1:
                        case 4:
                          return row?.showTargetStart && row?.showTargetEnd ? (
                            (() => {
                              const startDate = moment(row.showTargetStart, dateFormat).unix();
                              const endDate = moment(row.showTargetEnd, dateFormat).unix();
                              return (
                                <p title={formatOnlyDateRange(startDate, endDate)}>
                                   <i className="fal fa-calendar-clock"></i>
                                  {formatOnlyDateRange(startDate, endDate)}
                                </p>
                              );
                            })()
                          ) : (
                            "Invalid Date"
                          );                        
                        case 2: 
                        case 3: 
                          const formattedDate = formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix(), moment(row?.showCompletion, dateFormat).unix())
                          return row?.showTargetStart && row?.showCompletion ? (
                            <p title={formattedDate}>
                              <i className="fal fa-calendar-clock"></i>
                              {formattedDate}
                             </p>  
                          ) : (
                            "Invalid Date"
                          );                                             
                          default:
                            return (
                              <p title={formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }>
                              <i className="fal fa-calendar-clock"></i>
                              {formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }
                            </p>
                            )
                      }
                    } else if (row.subject_type === "mentored") {

                      switch (row.student_intake_status) {
                        case 0: 
                        return (
                          <p title={formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }>
                            <i className="fal fa-calendar-clock"></i>
                            {formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }
                          </p>
                        )  
                        case 1: 
                        case 4: 
                        return (
                          <p title={formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix() , moment(row.showTargetEnd, dateFormat).unix()) }>
                            <i className="fal fa-calendar-clock"></i>
                            {formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix() , moment(row.showTargetEnd, dateFormat).unix()) }
                          </p>
                        )  
                        case 2: 
                        case 3:
                          return (
                            <p title={formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix() , moment(row.showCompletion, dateFormat).unix()) }>
                              <i className="fal fa-calendar-clock"></i>
                              {formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix() , moment(row.showCompletion, dateFormat).unix()) }
                            </p>
                          )     
                        default: 
                        return (
                          <p title={formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }>
                            <i className="fal fa-calendar-clock"></i>
                            {formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }
                          </p>
                        )     
                      }
                    } else {
                      return row?.start && row?.end ? (
                        <p title={formatOnlyDateRange(row.start, row.end)}>
                          <i className="fal fa-calendar-days"></i>
                          {formatOnlyDateRange(row.start, row.end)}
                        </p>
                      ) : (
                        "Invalid Date"
                      );
                    }
                  })()
                ) : (

                  <p title={formatOnlyDateRange(row?.start, row?.end)}>
                    <i className="fal fa-calendar-days"></i>
                    {formatOnlyDateRange(row?.start, row?.end)}
                  </p>
                )}
                
              </div>

            </div>
          </div>
        </div>
        <div className={`lecture-detail-top-right d-flex ${history.location.pathname.includes("shortCourse") ? "mentored__short__course" : "mentored__course"}`}>
          <ul className="lec-dtl-rgt-ul m-0 d-flex list-unstyled align-items-center flex-wrap">
            
            
            {(props.isAdmin != 1 && (row?.subject_type=="shortcourse" || row.subject_type=="mentored")) ?             
              <MentoredSubject subjectContent={props.subjectContent} row={row} updateSubject={props.updateSubject} /> 
            : null}
          </ul>
        </div>
      </div>      
    </>
  );
};
export default SubjectHeadBox;